import { render } from "./BasketItem.vue?vue&type=template&id=38766d2e&scoped=true&ts=true"
import script from "./BasketItem.vue?vue&type=script&lang=ts"
export * from "./BasketItem.vue?vue&type=script&lang=ts"

import "./BasketItem.vue?vue&type=style&index=0&id=38766d2e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38766d2e"]])

export default __exports__